/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UndercarriagePartConditionResponse
 */
export interface UndercarriagePartConditionResponse {
    /**
     * 
     * @type {string}
     * @memberof UndercarriagePartConditionResponse
     */
    partCategory?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriagePartConditionResponse
     */
    partType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriagePartConditionResponse
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriagePartConditionResponse
     */
    positionLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriagePartConditionResponse
     */
    actionType?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriagePartConditionResponse
     */
    color?: string;
    /**
     * 
     * @type {number}
     * @memberof UndercarriagePartConditionResponse
     */
    wearPercentage?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriagePartConditionResponse
     */
    observedMeasurement?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriagePartConditionResponse
     */
    comments?: string | null;
}

/**
 * Check if a given object implements the UndercarriagePartConditionResponse interface.
 */
export function instanceOfUndercarriagePartConditionResponse(value: object): value is UndercarriagePartConditionResponse {
    return true;
}

export function UndercarriagePartConditionResponseFromJSON(json: any): UndercarriagePartConditionResponse {
    return UndercarriagePartConditionResponseFromJSONTyped(json, false);
}

export function UndercarriagePartConditionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriagePartConditionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'partCategory': json['partCategory'] == null ? undefined : json['partCategory'],
        'partType': json['partType'] == null ? undefined : json['partType'],
        'location': json['location'] == null ? undefined : json['location'],
        'positionLabel': json['positionLabel'] == null ? undefined : json['positionLabel'],
        'actionType': json['actionType'] == null ? undefined : json['actionType'],
        'color': json['color'] == null ? undefined : json['color'],
        'wearPercentage': json['wearPercentage'] == null ? undefined : json['wearPercentage'],
        'observedMeasurement': json['observedMeasurement'] == null ? undefined : json['observedMeasurement'],
        'comments': json['comments'] == null ? undefined : json['comments'],
    };
}

export function UndercarriagePartConditionResponseToJSON(json: any): UndercarriagePartConditionResponse {
    return UndercarriagePartConditionResponseToJSONTyped(json, false);
}

export function UndercarriagePartConditionResponseToJSONTyped(value?: UndercarriagePartConditionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partCategory': value['partCategory'],
        'partType': value['partType'],
        'location': value['location'],
        'positionLabel': value['positionLabel'],
        'actionType': value['actionType'],
        'color': value['color'],
        'wearPercentage': value['wearPercentage'],
        'observedMeasurement': value['observedMeasurement'],
        'comments': value['comments'],
    };
}

